// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_UdN","cls2":"WorkCard-cls2_6wM WorkCard-cls1_UdN"};